import { AbstractTooltip as Tooltip } from "../../../ToolTip/ToolTip";
import React, { useContext } from "react";
import classes from "../../../../utils/HTML/classes";
import { LessonPageActionsContext, PageContext } from "../../../../routes/builderContexts";

export interface PageAutoAdvanceProps {
  disabled?: boolean;
}

export const PageAutoAdvance = ({ disabled = false }: PageAutoAdvanceProps) => {
  const { handleRightSide } = useContext(LessonPageActionsContext);
  const { page } = useContext(PageContext);

  const handleAutoAdvance = () => () => {
    handleRightSide("shouldAutoPageForward");
  };

  return (
    <div className={classes("pageEditorActionListerRow", { "disabled-action": disabled })}>
      <div
        className={classes("pageListerActionButton auto-advance-p", {
          "auto-advance-p--disabled": disabled,
        })}
        data-tooltip-id="Auto Advance"
      >
        <p>Page Auto Advance</p>
        <div className="toggle toggle-switch">
          <input
            type="checkbox"
            className="toggle-checkbox"
            id="toggle-switch"
            checked={page.shouldAutoPageForward}
            onChange={handleAutoAdvance()}
            disabled={disabled}
          />
          <label htmlFor="toggle-switch" className="toggle-btn">
            <span className="toggle-feature" data-label-on="on" data-label-off="off"></span>
          </label>
        </div>
      </div>
      <Tooltip id={"Auto Advance"} />
    </div>
  );
};
